var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',{attrs:{"multiple":"","accordion":"","inheritAttrs":false},model:{value:(_vm.expandeditems),callback:function ($$v) {_vm.expandeditems=$$v},expression:"expandeditems"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }